import React, { useState } from "react"

const Fact = () => {
    const [fact, setFact] = useState(0)
    const facts = [
        "The NSA Utah Data Center has capacity of five zettabytes of data!", // https://www.npr.org/sections/alltechconsidered/2013/09/23/225381596/booting-up-new-nsa-data-farm-takes-root-in-utah
        "The average US household consumes 490.7 GB of data per month!", // https://headphonesaddict.com/average-internet-data-usage/
        "Facebook generates 4 petabytes of data per day!", // https://kinsta.com/blog/facebook-statistics/
    ]

    return (
        <div className="fact">
            <p className="note">Random Fact: {facts[fact]}
                <button title="Refresh fact" style={{ margin: "0 4px" }} onClick={() => setFact((fact + 1) % facts.length)}>↻</button>
            </p>
        </div>
    )
}

export default Fact
